export default __webpack_public_path__ + "static/media/Breakthrough badge.f05cce36.svg";